import { pStyles } from 'components/reusable-css';
import styled from 'styled-components';
import { variables } from 'variables';

export const NewBMStep4SC = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  width: 100%;
  // padding-top: 80px;
  padding-top: 45px;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
`;

export const StepDescription = styled.div`
  margin: 50px 0;
  font-size: ${(props) => props.theme.default?.p};
  ${(props) => pStyles(props.theme.resolutions)};
`;

export const ServerSizeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 10px;
`;

export const NewBMStep4SContainer = styled.div`
  padding: ${variables.pageContentPadding}px;
  padding-bottom: 80px;
`;
